module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "player2ModThree"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2047.40851,375.46313 C2047.10313,377.770117 2045.50569,378.24539 2043.52281,380.771565 C2041.20928,383.718986 2040.72524,389.442547 2038,394.002696 C2038.4763,395.183357 2042.3994,393.538743 2043.38593,391.693438 C2044.37246,389.848133 2045.13357,388.343748 2045.45328,387.885387 C2045.773,387.427026 2046.41315,387.538507 2046.55262,388.024624 C2046.69209,388.510741 2045.10055,405.381312 2045.40262,406.253956 C2045.70469,407.1266 2047.94101,407.426544 2048.43348,406.620188 C2048.92596,405.813832 2050.53291,392.507694 2050.76639,392.174573 C2050.99987,391.841452 2051.47086,392.072276 2051.65569,392.28203 C2051.84051,392.491785 2049.7094,406.655766 2049.97789,407.224877 C2050.24638,407.793987 2052.57113,407.981898 2052.87589,407.575055 C2053.18065,407.168212 2055.03347,393.016535 2055.32513,392.725425 C2055.61678,392.434315 2056.12197,392.531904 2056.29487,392.842602 C2056.46776,393.153301 2054.19726,406.721963 2054.48466,407.351377 C2054.77206,407.980792 2057.01385,408.261062 2057.29448,407.690899 C2057.5751,407.120737 2059.74412,393.461601 2059.98623,393.288646 C2060.22834,393.115691 2060.51827,393.169637 2060.70278,393.375229 C2060.88728,393.580822 2059.82835,403.850487 2060.11675,404.450444 C2060.40515,405.050401 2062.08623,405.38706 2062.42233,404.729037 C2062.75842,404.071013 2064.67734,378.956419 2064.88355,377.574714 C2065.57075,372.970089 2063.23657,367.791757 2057.346,367.079974 C2051.45542,366.368191 2048.06429,370.509068 2047.40851,375.46313 Z",
      "id": "player2_right_hand",
      "fill": "#AFD485",
      "transform": "translate(2051.500000, 387.500000) scale(-1, 1) translate(-2051.500000, -387.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2048.23328,333.065814 C2053.08105,333.65203 2056.52841,337.99763 2055.93317,342.771982 L2051.62213,377.350897 C2051.0269,382.125249 2046.61448,385.520403 2041.76672,384.934186 C2036.91895,384.34797 2033.47159,380.00237 2034.06683,375.228018 L2038.37787,340.649103 C2038.9731,335.874751 2043.38552,332.479597 2048.23328,333.065814 Z",
      "id": "player2_right_arm_bottom",
      "fill": "#AFD485",
      "transform": "translate(2045.000000, 359.000000) scale(-1, 1) translate(-2045.000000, -359.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2044.30508,273.065025 C2049.10803,273.644214 2052.52352,277.937724 2051.93379,282.654846 L2044.45922,342.442586 C2043.86949,347.159708 2039.49786,350.514165 2034.69492,349.934975 C2029.89197,349.355786 2026.47648,345.062276 2027.06621,340.345154 L2034.54078,280.557414 C2035.13051,275.840292 2039.50214,272.485835 2044.30508,273.065025 Z",
      "id": "player2_right_arm_top",
      "fill": "#AFD485",
      "transform": "translate(2039.500000, 311.500000) scale(-1, 1) translate(-2039.500000, -311.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2044.10219,273.084126 C2050.15025,273.81848 2054.51291,279.173455 2053.95135,285.173565 L2049.94321,328 L2025,324.971401 L2031.58802,282.458214 C2032.51102,276.501991 2038.05413,272.349771 2044.10219,273.084126 Z",
      "id": "player2_right_shoulder",
      "fill": "#A4CA7A",
      "transform": "translate(2039.500000, 300.500000) scale(-1, 1) translate(-2039.500000, -300.500000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player2_right_sock",
      "fill": "#CDF1A5",
      "transform": "translate(2032.000000, 506.000000) scale(-1, 1) translate(-2032.000000, -506.000000) ",
      "points": "2024 503 2040 503 2040 509 2024 509"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2033.00177,508.665873 C2032.85106,503.850903 2042.3985,503.705721 2041.87392,508.665873 C2041.50809,512.125013 2042.39801,513.178032 2045.34871,516.010793 C2048.29941,518.843554 2055.79152,522.266607 2058,523.07268 C2057.44361,524.777215 2052.85296,525.282636 2049.63007,526 C2037.5301,521.226885 2033.15247,513.480843 2033.00177,508.665873 Z",
      "id": "player2_right_shoe_6",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2033.55083,508.213432 C2032.81223,506.738356 2026.40203,506.45872 2023.85727,508.213432 C2022.73004,507.726536 2020.52095,506.871358 2020.04718,508.670772 C2019.73133,509.870381 2021.00136,510.997526 2023.85727,512.052208 C2023.63519,525.78356 2023.63519,533.766158 2023.85727,536 C2028.34437,536 2059.08605,536 2064.7261,536 C2065.02387,533.554828 2066.68149,525.585971 2056.21206,522.608673 C2055.12575,523.435422 2053.95291,524.315951 2050.17414,525.585971 C2036.2451,519.597147 2034.28942,509.688508 2033.55083,508.213432 Z",
      "id": "player2_right_shoe_5",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2053.19978,532.534846 C2050.30411,532.534846 2028.22326,532.534846 2024,532.534846 C2024.03032,532.950031 2024.03032,534.105082 2024,536 C2052.52439,536 2067.13609,536 2067.83509,536 C2068.0761,534.017476 2069.06047,527.212948 2060.85179,524.06934 C2058.5937,523.405402 2053.51408,527.605902 2053.19978,532.534846 Z",
      "id": "player2_right_shoe_4",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2044.19956,523.5913 C2044.95447,522.35308 2049.81518,520.265232 2051.59079,520.011776 C2052.32957,519.906322 2053.09428,520.52386 2052.9905,521.273392 C2050.757,521.707432 2046.49705,523.790686 2045.75968,524.621404 C2045.02231,525.452121 2043.44466,524.82952 2044.19956,523.5913 Z",
      "id": "player2_right_shoe_3",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2038.19956,520.5913 C2038.95447,519.35308 2043.81518,517.265232 2045.59079,517.011776 C2046.32957,516.906322 2047.09428,517.52386 2046.9905,518.273392 C2044.757,518.707432 2040.49705,520.790686 2039.75968,521.621404 C2039.02231,522.452121 2037.44466,521.82952 2038.19956,520.5913 Z",
      "id": "player2_right_shoe_2",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2035.18787,516.590521 C2035.89853,515.351616 2040.47441,513.262614 2042.14597,513.009018 C2042.84145,512.903505 2043.07658,513.743687 2042.97888,514.493633 C2040.87626,514.927914 2037.35072,516.790017 2036.65656,517.621194 C2035.9624,518.452371 2034.47721,517.829425 2035.18787,516.590521 Z",
      "id": "player2_right_shoe_1",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2032,431 L2032,431 L2032,431 C2036.41828,431 2040,434.581722 2040,439 L2040,503 L2024,503 L2024,439 L2024,439 C2024,434.581722 2027.58172,431 2032,431 Z",
      "id": "player2_right_leg_bottom",
      "fill": "#AFD485",
      "transform": "translate(2032.000000, 467.000000) scale(-1, 1) translate(-2032.000000, -467.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2032,375 L2032,375 L2032,375 C2036.41828,375 2040,378.581722 2040,383 L2040,439 L2040,439 C2040,443.418278 2036.41828,447 2032,447 L2032,447 L2032,447 C2027.58172,447 2024,443.418278 2024,439 L2024,383 L2024,383 C2024,378.581722 2027.58172,375 2032,375 Z",
      "id": "player2_right_leg_top",
      "fill": "#AFD485",
      "transform": "translate(2032.000000, 411.000000) scale(-1, 1) translate(-2032.000000, -411.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2033,356 L2033,356 L2033,356 C2040.73199,356 2047,362.268014 2047,370 L2047,429 L2019,429 L2019,370 L2019,370 C2019,362.268014 2025.26801,356 2033,356 Z",
      "id": "player2_right_leg_pant",
      "fill": "#6D8C4A",
      "transform": "translate(2033.000000, 392.500000) scale(-1, 1) translate(-2033.000000, -392.500000) "
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "player2_left_sock",
      "fill": "#CDF1A5",
      "transform": "translate(1996.000000, 506.000000) scale(-1, 1) translate(-1996.000000, -506.000000) ",
      "points": "1988 503 2004 503 2004 509 1988 509"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1996.00177,508.665873 C1995.85106,503.850903 2005.3985,503.705721 2004.87392,508.665873 C2004.50809,512.125013 2005.39801,513.178032 2008.34871,516.010793 C2011.29941,518.843554 2018.79152,522.266607 2021,523.07268 C2020.44361,524.777215 2015.85296,525.282636 2012.63007,526 C2000.5301,521.226885 1996.15247,513.480843 1996.00177,508.665873 Z",
      "id": "player2_left_shoe_6",
      "fill": "#94B96B"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1997.55083,508.213432 C1996.81223,506.738356 1990.40203,506.45872 1987.85727,508.213432 C1986.73004,507.726536 1984.52095,506.871358 1984.04718,508.670772 C1983.73133,509.870381 1985.00136,510.997526 1987.85727,512.052208 C1987.63519,525.78356 1987.63519,533.766158 1987.85727,536 C1992.34437,536 2023.08605,536 2028.7261,536 C2029.02387,533.554828 2030.68149,525.585971 2020.21206,522.608673 C2019.12575,523.435422 2017.95291,524.315951 2014.17414,525.585971 C2000.2451,519.597147 1998.28942,509.688508 1997.55083,508.213432 Z",
      "id": "player2_left_shoe_5",
      "fill": "#A4CA7A"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2017.19978,532.534846 C2014.30411,532.534846 1992.22326,532.534846 1988,532.534846 C1988.03032,532.950031 1988.03032,534.105082 1988,536 C2016.52439,536 2031.13609,536 2031.83509,536 C2032.0761,534.017476 2033.06047,527.212948 2024.85179,524.06934 C2022.5937,523.405402 2017.51408,527.605902 2017.19978,532.534846 Z",
      "id": "player2_left_shoe_4",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2007.19956,523.5913 C2007.95447,522.35308 2012.81518,520.265232 2014.59079,520.011776 C2015.32957,519.906322 2016.09428,520.52386 2015.9905,521.273392 C2013.757,521.707432 2009.49705,523.790686 2008.75968,524.621404 C2008.02231,525.452121 2006.44466,524.82952 2007.19956,523.5913 Z",
      "id": "player2_left_shoe_3",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2002.19956,520.5913 C2002.95447,519.35308 2007.81518,517.265232 2009.59079,517.011776 C2010.32957,516.906322 2011.09428,517.52386 2010.9905,518.273392 C2008.757,518.707432 2004.49705,520.790686 2003.75968,521.621404 C2003.02231,522.452121 2001.44466,521.82952 2002.19956,520.5913 Z",
      "id": "player2_left_shoe_2",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1999.18787,516.590521 C1999.89853,515.351616 2004.47441,513.262614 2006.14597,513.009018 C2006.84145,512.903505 2007.07658,513.743687 2006.97888,514.493633 C2004.87626,514.927914 2001.35072,516.790017 2000.65656,517.621194 C1999.9624,518.452371 1998.47721,517.829425 1999.18787,516.590521 Z",
      "id": "player2_left_shoe_1",
      "fill": "#CDF1A5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1996,431 L1996,431 L1996,431 C2000.41828,431 2004,434.581722 2004,439 L2004,503 L1988,503 L1988,439 L1988,439 C1988,434.581722 1991.58172,431 1996,431 Z",
      "id": "player2_left_leg_bottom",
      "fill": "#AFD485",
      "transform": "translate(1996.000000, 467.000000) scale(-1, 1) translate(-1996.000000, -467.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1996,375 L1996,375 L1996,375 C2000.41828,375 2004,378.581722 2004,383 L2004,439 L2004,439 C2004,443.418278 2000.41828,447 1996,447 L1996,447 L1996,447 C1991.58172,447 1988,443.418278 1988,439 L1988,383 L1988,383 C1988,378.581722 1991.58172,375 1996,375 Z",
      "id": "player2_left_leg_top",
      "fill": "#AFD485",
      "transform": "translate(1996.000000, 411.000000) scale(-1, 1) translate(-1996.000000, -411.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1997,356 L1997,356 L1997,356 C2004.73199,356 2011,362.268014 2011,370 L2011,429 L1983,429 L1983,370 L1983,370 C1983,362.268014 1989.26801,356 1997,356 Z",
      "id": "player2_left_leg_pant",
      "fill": "#6D8C4A",
      "transform": "translate(1997.000000, 392.500000) scale(-1, 1) translate(-1997.000000, -392.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1983,356 L2047,356 L2047,370 L2047,370 C2047,386.568542 2033.56854,400 2017,400 L2013,400 L2013,400 C1996.43146,400 1983,386.568542 1983,370 L1983,356 Z",
      "id": "player2_hip",
      "fill": "#4A4A4A",
      "transform": "translate(2015.000000, 378.000000) scale(-1, 1) translate(-2015.000000, -378.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2014.2838,262.001639 C2025.34039,261.978066 2025.58609,262.145841 2025.5857,266.80406 C2053,271.856775 2052.59214,363.383418 2053,399.648732 C2045.88853,401.786448 1985.17084,401.039433 1977,399.795255 C1977.93202,368.667684 1977,269.863867 2001.72701,266.80406 C2001.72701,262.259017 2003.22722,262.025212 2014.2838,262.001639 Z",
      "id": "player2_shirt",
      "fill": "#CDF1A5",
      "transform": "translate(2015.000000, 331.500000) scale(-1, 1) translate(-2015.000000, -331.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1987.87656,376.490505 C1987.85956,378.81154 1986.36885,379.473323 1984.75259,382.212132 C1982.86681,385.407646 1983.08978,391.133322 1981,395.975103 C1981.60438,397.087259 1985.20761,394.989257 1985.94059,393.043899 C1986.67356,391.098541 1987.22929,389.517752 1987.48372,389.025604 C1987.73815,388.533456 1988.37204,388.567251 1988.56599,389.031941 C1988.75993,389.49663 1989.25745,406.393155 1989.65572,407.221147 C1990.05398,408.049139 1992.2576,408.078569 1992.63739,407.221147 C1993.01717,406.363725 1992.9656,392.995036 1993.1516,392.637225 C1993.3376,392.279415 1993.82198,392.451631 1994.02646,392.637225 C1994.23095,392.82282 1993.87825,407.103707 1994.20728,407.635143 C1994.5363,408.166578 1996.81208,408.074485 1997.05824,407.635143 C1997.30441,407.1958 1997.38889,392.960396 1997.63635,392.637225 C1997.88381,392.314055 1998.38521,392.350245 1998.59035,392.637225 C1998.79548,392.924206 1998.2357,406.632259 1998.59035,407.221147 C1998.945,407.810035 2001.15153,407.819329 2001.35456,407.221147 C2001.55759,406.622965 2002.00807,392.837464 2002.2218,392.637225 C2002.43553,392.436987 2002.72304,392.455715 2002.92672,392.637225 C2003.1304,392.818736 2003.34591,403.114983 2003.69796,403.674582 C2004.05002,404.23418 2005.71996,404.366406 2005.96612,403.674582 C2006.21228,402.982758 2005.0352,377.883413 2005.06798,376.490505 C2005.1772,371.848545 2002.28885,367 1996.49389,367 C1990.69892,367 1987.91308,371.506275 1987.87656,376.490505 Z",
      "id": "player2_left_hand",
      "fill": "#AFD485",
      "transform": "translate(1993.500000, 387.500000) scale(-1, 1) translate(-1993.500000, -387.500000) "
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player2_left_arm_bottom",
      "fill": "#AFD485",
      "transform": "translate(1991.500000, 359.000000) scale(-1, 1) translate(-1991.500000, -359.000000) ",
      "x": "1983",
      "y": "333",
      "width": "17",
      "height": "52",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "player2_left_arm_top",
      "fill": "#AFD485",
      "transform": "translate(1991.500000, 311.000000) scale(-1, 1) translate(-1991.500000, -311.000000) ",
      "x": "1983",
      "y": "272",
      "width": "17",
      "height": "78",
      "rx": "8.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1991.5,272 L1991.5,272 L1991.5,272 C1997.56195,272 2002.52632,276.817845 2002.70788,282.877076 L2004,326 L1979,326 L1980.29212,282.877076 L1980.29212,282.877076 C1980.47368,276.817845 1985.43805,272 1991.5,272 Z",
      "id": "player2_left_shoulder",
      "fill": "#A4CA7A",
      "transform": "translate(1991.500000, 299.000000) scale(-1, 1) translate(-1991.500000, -299.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2008.88235,257.480593 C2009.55234,261.65277 2009.91488,264.574073 2008,266.86896 C2009.53021,269.61594 2021.55666,269.80321 2023,266.86896 C2021.26588,264.518009 2021.0881,262.142292 2022.11765,257.480593 C2020.83828,254.117067 2010.66882,254.229684 2008.88235,257.480593 Z",
      "id": "player2_neck",
      "fill": "#AFD485",
      "transform": "translate(2015.500000, 262.000000) scale(-1, 1) translate(-2015.500000, -262.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2001.58776,185.014081 C2017.39573,185.328865 2030.7579,195.109428 2032.25218,212.783954 C2033.74647,230.458481 2025.73355,239.987301 2023.33621,242.115557 C2034.78785,242.164871 2027.93267,262.067661 2044.99995,253.668566 C2045.02227,260.949474 2037.16808,267.123131 2030.56196,267.815602 C2023.95583,268.508074 2011.5229,268.026898 2013.01444,252.125588 C2011.04439,253.820124 2004.92861,258.823879 1996.61692,259.01132 C1988.30523,259.198761 1973.82699,251.109585 1970.72611,237.493409 C1969.33297,236.61378 1962.54971,225.387381 1968.23817,205.323291 C1972.69402,189.606795 1985.77978,184.699298 2001.58776,185.014081 Z",
      "id": "player2_hair",
      "fill": "#6D8C4A",
      "transform": "translate(2005.500000, 226.500000) scale(-1, 1) translate(-2005.500000, -226.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2034.99543,227.861622 C2036.69734,226.853075 2039.14059,225.571857 2041.91073,227.861622 C2044.28019,229.820188 2042.49908,237.503854 2039.30277,241.759044 C2036.13676,245.973905 2030.98664,246.848991 2028.96515,245.233399 C2024.7003,254.919776 2013.83099,260.063451 2006.56698,259.999409 C1987.1197,259.827957 1979,239.993829 1979,223.518678 C1979,209.677703 1986.63226,201.806861 2000.55905,200.282448 C2001.02053,201.998472 2005.52982,208.351172 2006.7169,208.637118 C2006.56698,206.942132 2006.17853,201.521073 2006.37682,200 C2007.02738,201.636851 2009.23756,206.420787 2010.44467,206.655397 C2010.28656,204.476312 2010.27454,201.834905 2010.44467,200.153098 C2024.2478,201.136792 2036.69432,207.401531 2034.99543,227.861622 Z",
      "id": "player2_face",
      "fill": "#AFD485",
      "fill-rule": "nonzero",
      "transform": "translate(2011.000000, 230.000000) scale(-1, 1) translate(-2011.000000, -230.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1981.79252,234.32904 C1983.39642,231.130526 1985.90402,228.165694 1988.9626,229.21508 C1992.02117,230.264465 1988.10485,242.017771 1980,241.99998 C1980.93805,241.449484 1983.50211,238.887903 1983.58504,236.88602 C1983.66797,234.884137 1982.98757,233.881235 1981.79252,234.32904 Z",
      "id": "player2_ear",
      "fill": "#94B96B",
      "transform": "translate(1985.000000, 235.500000) scale(-1, 1) translate(-1985.000000, -235.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2012.00475,251.089 C2013.37759,251.383 2021.09978,251.4565 2023.67385,251.0155 C2025.04669,250.795 2021.95781,253 2016.80967,253 C2011.66154,253 2012.00475,251.089 2012.00475,251.089 Z",
      "id": "player2_mouth_bottom",
      "fill": "#94B96B",
      "fill-rule": "nonzero",
      "transform": "translate(2018.000000, 252.000000) scale(-1, 1) translate(-2018.000000, -252.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2009,250.655172 C2009,249.758621 2009.84532,249 2014.241,249 C2017.28416,249 2022.18703,250.241379 2024.63847,249.689655 C2025.14566,249.551724 2025.14566,249.896552 2024.4694,250.103448 C2021.34171,251 2018.29855,251 2013.64927,251 C2010.60611,250.931034 2009,250.655172 2009,250.655172 Z",
      "id": "player2_mouth_top",
      "fill": "#94B96B",
      "fill-rule": "nonzero",
      "transform": "translate(2017.000000, 250.000000) scale(-1, 1) translate(-2017.000000, -250.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2019.11476,229.278291 C2019.11476,227.646167 2023.38629,227.503139 2023.38839,229.278291 C2023.39049,231.053443 2024.76206,240.316183 2023.39049,241.962135 C2022.01891,243.608088 2017.987,243.056616 2017.36303,241.962135 C2016.73906,240.867654 2016.85672,239.082802 2018.21024,238.585611 C2019.56376,238.088419 2019.11476,230.910415 2019.11476,229.278291 Z",
      "id": "player2_nose",
      "fill": "#94B96B",
      "transform": "translate(2020.500000, 235.500000) scale(-1, 1) translate(-2020.500000, -235.500000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1996,231.594484 C1998.28918,225.033766 2008.47003,224.032491 2010,229.713778 C2010.00726,237.385327 1997.66412,238.062908 1996,231.594484 Z",
      "id": "player2_left_eye_whites",
      "fill": "#CDF1A5",
      "transform": "translate(2003.000000, 231.000000) scale(-1, 1) translate(-2003.000000, -231.000000) "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_left_pupil",
      "fill": "#778F5F",
      "transform": "translate(2001.500000, 231.500000) scale(-1, 1) translate(-2001.500000, -231.500000) ",
      "cx": "2001.5",
      "cy": "231.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2038,231.594484 C2035.71082,225.033766 2025.52997,224.032491 2024,229.713778 C2023.99274,237.385327 2036.33588,238.062908 2038,231.594484 Z",
      "id": "player2_right_eye_whites",
      "fill": "#CDF1A5",
      "transform": "translate(2031.000000, 231.000000) scale(-1, 1) translate(-2031.000000, -231.000000) "
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "player2_right_pupil",
      "fill": "#778F5F",
      "transform": "translate(2029.500000, 231.500000) scale(-1, 1) translate(-2029.500000, -231.500000) ",
      "cx": "2029.5",
      "cy": "231.5",
      "r": "3.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M2037.99423,222.927551 C2036.44262,222.861084 2028.45183,222.661682 2025.34861,222.994019 C2023.87458,223.126953 2027.21054,221 2032.79634,221 C2038.38213,221 2037.99423,222.927551 2037.99423,222.927551 Z",
      "id": "player2_right_brow",
      "fill": "#6D8C4A",
      "fill-rule": "nonzero",
      "transform": "translate(2031.500000, 222.000000) scale(-1, 1) translate(-2031.500000, -222.000000) "
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1997.00537,222.92385 C1998.52147,222.859722 2006.55679,222.603208 2009.66479,222.987978 C2011.10509,223.180363 2007.76967,221 2002.23591,221 C1996.62635,221 1997.00537,222.92385 1997.00537,222.92385 Z",
      "id": "player2_left_brow",
      "fill": "#6D8C4A",
      "fill-rule": "nonzero",
      "transform": "translate(2003.500000, 222.000000) scale(-1, 1) translate(-2003.500000, -222.000000) "
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ead05d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_3/svg/background/player2ModThree.vue
// module id = 740
// module chunks = 1